import { createFileRoute, redirect } from '@tanstack/react-router'
import { ImportExportPage } from '../pages/ImportExportPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/import-export' as any)({
    component: ImportExportPage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})
